"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsMobileDevice = useIsMobileDevice;

/**
 * SPDX-FileCopyrightText: © 2022 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function useIsMobileDevice() {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.screen.width <= 700;
}